import * as React from 'react';
import { classes } from './Badge.st.css';
import { BadgePriority } from './types';
import { BadgeBase } from './Badge.base';
import classnames from 'classnames';
export class Badge extends React.Component {
    render() {
        const { className, priority, ...rest } = this.props;
        return (React.createElement(BadgeBase, { className: classnames(classes.root, classes[`priority-${priority}`], className), "data-priority": priority, ...rest }));
    }
}
Badge.displayName = 'Badge';
Badge.defaultProps = { priority: BadgePriority.default };
//# sourceMappingURL=Badge.js.map